export default __webpack_public_path__ + "static/media/datepick.c71acd9f.png";